import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const orgChatState = (state: RootState) => state.orgChat;

const selectMessages = createSelector(orgChatState, (state) => state.messages);

const selectMembers = createSelector(orgChatState, (state) => state.members);

const selectHasMore = createSelector(orgChatState, (state) => state.hasMore);

const selectLoading = createSelector(orgChatState, (state) => state.loading);

const selectSending = createSelector(orgChatState, (state) => state.sending);

const selectUnreadCount = createSelector(
  orgChatState,
  (state) => state.unreadCount,
);

export const orgChatSliceSelectors = {
  selectMessages,
  selectMembers,
  selectHasMore,
  selectLoading,
  selectSending,
  selectUnreadCount,
};
